import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider, createTheme, type MantineColorsTuple } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/charts/styles.css';
import '@fontsource-variable/onest';
import { App } from './App.js';
import { PwaUpdateBanner } from './pwa-update.js';
import { RADIUS_CARD, RADIUS_CONTROL, TEXT } from './theme/tokens.js';

const fontStack = "'Onest Variable', Inter, Arial, sans-serif";

/** Бирюзовый акцент внутреннего портала; 6-й оттенок — основной (#09AF9A). */
const eurasiaTeal: MantineColorsTuple = [
  '#E6F7F4', '#CCEFEA', '#99DFD5', '#66CFC0', '#33BFAB',
  '#09AF9A', '#078C7B', '#05695C', '#04463E', '#02231F',
];

/** Тёмный navy для текста и служебных поверхностей. */
const eurasiaNavy: MantineColorsTuple = [
  '#EDF0F4', '#D6DCE5', '#AEB9CB', '#8596B1', '#5D7397',
  '#12213D', '#0F1B31', '#0B1425', '#080E19', '#04070C',
];

const theme = createTheme({
  fontFamily: fontStack,
  headings: { fontFamily: fontStack },
  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '75em',
    xl: '88em',
  },
  colors: { eurasiaTeal, eurasiaNavy },
  primaryColor: 'eurasiaTeal',
  primaryShade: 5,
  black: TEXT,
  defaultRadius: RADIUS_CONTROL,
  components: {
    Card: { defaultProps: { radius: RADIUS_CARD } },
    Paper: { defaultProps: { radius: RADIUS_CARD } },
    Modal: { defaultProps: { radius: RADIUS_CARD } },
    Button: { defaultProps: { radius: RADIUS_CONTROL } },
    TextInput: { defaultProps: { radius: RADIUS_CONTROL } },
    Textarea: { defaultProps: { radius: RADIUS_CONTROL } },
    NumberInput: { defaultProps: { radius: RADIUS_CONTROL } },
    Select: { defaultProps: { radius: RADIUS_CONTROL } },
    MultiSelect: { defaultProps: { radius: RADIUS_CONTROL } },
    Autocomplete: { defaultProps: { radius: RADIUS_CONTROL } },
    Alert: { defaultProps: { radius: RADIUS_CONTROL } },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <App />
      <PwaUpdateBanner />
    </MantineProvider>
  </StrictMode>,
);
